/**
 * Feature Flags
 * 
 * Toggle features on/off for different releases.
 * This provides a centralized way to enable/disable features without hunting through code.
 */

export const FEATURES = {
  /**
   * Authentication & User Accounts
   * Set to true when ready to launch sign-in/sign-up functionality
   */
  AUTHENTICATION: false,

  // Future feature flags:
  // CLOUD_SYNC: false,
  // PREMIUM_SUBSCRIPTIONS: false,
  // ANALYTICS: false,
} as const;
